module.exports = __webpack_public_path__ + "img/roanoke-logo.bd5b986b.png";